import * as Yup from 'yup';
import { DictionaryIppcActivity } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryIppcActivity>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
